import { type ReactNode } from 'react'
import { type PermissionType, type PermissionListItem } from '@terros/common'
import { TDrawer } from '../terros'
import { PermissionSource } from './PermissionSource'

type Props = {
  opened: boolean
  close: () => void
  permissions: PermissionListItem
  permissionType: PermissionType
}

export const PermissionAuditDrawer = ({ opened, close, permissions, permissionType }: Props): ReactNode => {
  return (
    <TDrawer opened={opened} size='lg' title='Permission Details & History' onClose={close}>
      <PermissionSource permissionInfo={permissions} permissionType={permissionType} />
    </TDrawer>
  )
}
